import React from "react";
import { useSelector } from "react-redux";
import { CustomTooltip, icon, IconComponent } from "../../../../../../../../../../common/components";
import { translate } from "../../../../../../../../../../common/providers";
import styles from "./SavingIcon.module.css";

const SavingIcon = () => {
	const isSaving = useSelector(({ note }) => note.isSaving);
	return (
		<CustomTooltip
			title={translate(
				isSaving ? "notes.note-selector.save-tooltip.saving" : "notes.note-selector.save-tooltip.saved"
			)}
		>
			<span
				className={`${styles.iconWrapper} ${
					isSaving ? styles["iconWrapper--saving"] : styles["iconWrapper--saved"]
				}`}
			>
				<IconComponent
					color="var(--blue-500)"
					icon={(isSaving && icon.faFloppyDiskRegular) || icon.faFloppyDisk}
					size="xs"
				/>
			</span>
		</CustomTooltip>
	);
};

export default SavingIcon;
